<template>
  <div>
    <modal-cadu close :width="600" style="overflow: hidden;" v-model="valueData">
      <div slot="all" class="px-10 pt-10 pb-4">
        <div slot="header" class="pb-6">
            <div class="font-primaria title font-weight-bold pb-4" style="color: #00995D">
                ADICIONAR NOME CERTIFICAÇÃO/SELO
            </div>
        </div>
        <div slot="body">
          <ValidationObserver ref="observer">
            <div class="fontColor--text">
              <v-row align="center">
                <v-col cols="12" md="5" class="py-1">
                  <div>Nome Certificação/Selo:</div>
                </v-col>
                <v-col cols="12" md="5" class="py-1">
                  <validation-provider
                    name="area"
                    mode="eager"
                    rules="required"
                    v-slot="{ errors }"
                    ref="nome"
                  >
                    <input-cadu
                      :max="150"
                      :errorMessage="errors[0]"
                      :onlyUpperCase="false"
                      v-model="seloSelecionado.nome"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" md="5" class="py-1">
                  <div>Tooltip:</div>
                </v-col>
                <v-col cols="12" md="5" class="py-1">
                  <validation-provider
                    name="area"
                    mode="eager"
                    rules="required|max:150"
                    v-slot="{ errors }"
                    ref="descricao"
                  >
                    <input-cadu :errorMessage="errors[0]" v-model="descricao" max="150" :onlyUpperCase="false"/>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" md="5" class="py-1">
                  <div>Upload Imagem:</div>
                </v-col>
                <v-col cols="12" md="5" class="py-1">
                  <validation-provider
                    name="area"
                    mode="eager"
                    rules="required"
                    v-slot="{ errors }"
                    ref="nomeArquivo"
                  >
                    <input-cadu
                      :onlyUpperCase="false"
                      :errorMessage="errors[0]"
                      :value="nomeArquivo"
                      disabled
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="auto" class="pl-0">
                  <div class="drag-doc-area">
                    <input
                      type="file"
                      @input="filesChange($event)"
                      accept=".jpg, .jpeg, .png"
                      class="input-file"
                      :value="fileInput"
                    />
                    <a :style="colorProcurar">procurar</a>
                  </div>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" md="5" class="py-1">
                  <div>Status:</div>
                </v-col>
                <v-col cols="2" class="pr-0">{{status ? 'Ativa': 'Inativa'}}</v-col>
                <v-col cols="auto" class="py-1">
                  <switch-cadu v-model="status" />
                </v-col>
              </v-row>
            </div>
          </ValidationObserver>
        </div>
        <div slot="footer">
          <v-row justify="start">
            <v-col>
              <button-cadu @click="$emit('input', false)">VOLTAR</button-cadu>
            </v-col>
            <v-row justify="end">
              <v-col cols="auto">
                <button-cadu @click="salvar">SALVAR</button-cadu>
              </v-col>
            </v-row>
          </v-row>
        </div>
      </div>
    </modal-cadu>
    <overlay-loading v-model="loadingOverlay"/>
    <error-modal :value="showError" @input="fecharModalErro" :errObj="errObj" />
    <SucessoModal
        :genericMessage="genericMessage"
        :showSucess="showSucess"
        @close="fecharModalSucesso"
    />
  </div>
</template>

<script>
import ModalMixin from '@/Mixins/ModalMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ParametrosGerais from '@/services/ParametrosGerais/ParametrosGerais'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [ModalMixin],
  data () {
    return {
      listaTipoSelo: [],
      seloSelecionado: {
        nome: '',
        id: ''
      },
      status: false,
      fileInput: '',
      formData: new FormData(),
      descricao: '',
      parametrosGerais: '',
      nomeArquivo: '',
      showSucess: false,
      loadingOverlay: false,
      arquivo: '',
      errObj: {},
      showError: false,
      error: false,
      genericMessage: '',
      colorProcurar: {
        color: '#1492E6'
      },
      nomeTemp: ''
    }
  },
  beforeMount () {
    this.parametrosGerais = new ParametrosGerais(
      localStorage.getItem('tokenBearer'),
      this.$appConfig.config.API
    )
  },
  methods: {
    fecharModalSucesso () {
      this.showSucess = false
      this.$emit('att', this.nomeTemp)
    },
    async fecharModalErro () {
      this.showError = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    limparCampos () {
      this.arquivo = null
      this.nomeArquivo = ''
      this.seloSelecionado.nome = ''
      this.descricao = ''
      this.status = false
      this.formData = new FormData()
      this.colorProcurar.color = '#1492E6'
    },
    async salvar () {
      const arr = ['nome', 'descricao', 'nomeArquivo']
      const res = await Promise.all(arr.map(async (el) => this.$refs[el].validate()))
      this.colorProcurar.color = this.nomeArquivo ? '#1492E6' : '#ED1651'
      // const bool = res[0].valid, bool2 = res[1].valid, bool3 = res[2].valid

      if (res.find(el => el.valid !== true)) return
      this.genericMessage = this.seloSelecionado.nome + ' criado com sucesso!'

      if (this.formData.has('arquivo')) this.formData.set('arquivo', this.arquivo)
      else this.formData.append('arquivo', this.arquivo)
      if (this.formData.has('ativo')) this.formData.set('ativo', this.status)
      else this.formData.append('ativo', this.status)
      if (this.formData.has('descricao')) this.formData.set('descricao', this.descricao)
      else this.formData.append('descricao', this.descricao)
      if (this.formData.has('nome')) this.formData.set('nome', this.seloSelecionado.nome)
      else this.formData.append('nome', this.seloSelecionado.nome)

      this.loadingOverlay = true
      await this.promiseGeneric(
        this.parametrosGerais,
        'postParametroSimples',
        this.formData
      )
      this.loadingOverlay = false
      this.nomeTemp = this.seloSelecionado.nome
      this.showSucess = true
      this.$emit('input', false)
    },
    filesChange (e) {
      const file = e.target.files[0]
      this.arquivo = file
      this.nomeArquivo = file.name
      this.colorProcurar.color = '#1492E6'
    },
    async promiseGeneric (className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.setError(err)
      }
    },
    setError (err) {
      if (err.response) {
        this.loadingOverlay = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
      throw err
    }
  },
  watch: {
    valueData () {
      if (!this.valueData) {
        this.limparCampos()
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.drag-doc-area
  border-radius: 22px
  position: relative
  width: fit-content
  height: fit-content
  background: none

.input-file
  opacity: 0
  position: absolute
  top: 0
  height: 100%
  width: 100%
</style>
